import {useNavigate} from "react-router";
import {store} from "../index";

export const toggleGlobalLoader = (boolean) => ({
    type: 'TOGGLE_GLOBAL_LOADER',
    boolean
})


export const setSubdomainInfo = (data) => ({
    type: 'SET_SUBDOMAIN_INFO',
    data
})


export const updateNavInstructions = (data) => ({
    type: 'UPDATE_NAV_INSTRUCTIONS',
    data
})

export const setVar = (data) => ({
    type: 'SET_SESSION_VAR',
    data,
})

export const clearVars = (data) => ({
    type: 'CLEAR_SESSION_VARS'
})


// session redirect
// a series of actions to make sure the user gets back to where they are supposed to be when they log in
// just a wrapper around the setVar call

export const setOnLoginPath = (onLoginPath) => {
    store.dispatch(setVar({onLoginPath}));
}

export const clearLoginPath = () => {
    store.dispatch(setVar({onLoginPath: null}));
}